/**
 * Checkout Redux Reducer
 */

import * as actions from '../actions/checkout';

import * as update from 'immutability-helper';
import { union } from 'lodash';
import { Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { CheckoutStepId, CheckoutStepsOrder } from '../../components/pages/Checkout/config';

type ReducerState = ICheckoutState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const defaultList = [];

const initialState: ReducerState = {
  activeStep: '',
  completedSteps: defaultList,
  steps: defaultList,
};

const registerStepHandler: Handler<{ id: string }> = (state, { id }) => ({
  ...state,
  steps: union(state.steps, [id]),
});
const setActiveStepHandler: Handler<{ id: string }> = (state, { id }) => {
  const activeStepIndex = CheckoutStepsOrder[id];
  const completedSteps = state.completedSteps.reduce<string[]>((acc, step) => {
    if (CheckoutStepsOrder[step] < activeStepIndex) {
      acc.push(step);
    }
    return acc;
  }, []);
  return { ...state, activeStep: id, completedSteps };
};
const completeStepHandler: Handler<{ id: string }> = (state, { id }) => ({
  ...state,
  // IMPORTANT: active step should be set to 'order placed' at the end of the
  // checkout process to make sure that the 'project-details' checkout step
  // that gets set immediately after this step can be distinguished from the
  // initial 'project-details' step that gets set when the user lands on it
  // at the beginning of the checkout process. This is needed for correctly
  // recording analytics. See /public/analytics/events/checkout.ts.
  activeStep: state.steps[state.steps.indexOf(id) + 1] || CheckoutStepId.orderPlaced,
  completedSteps: union(state.completedSteps, [id]),
});
const removeCompletedStepHandler: Handler<{ id: string }> = (state, { id }) => ({
  ...state,
  completedSteps: update(state.completedSteps, {
    $splice: [[state.completedSteps.indexOf(id), 1]],
  }),
});
const consumeLocallyStoredStepHandler: Handler<{ id: string; }> = (state, { id }) => ({
  ...state,
  localStorage: update(state.localStorage, {
    $unset: [id],
  }),
});
const setCheckoutFromLocalStorageHandler: Handler<Success<void, ICheckoutStepLocalStorage[]>> =
  (state, { result }) => {
    return {
      ...state,
      localStorage: result,
    };
  };

const placeOrderCompleteHandler: Handler = () => ({
  ...initialState,
  activeStep: CheckoutStepId.orderPlaced,
});

export default reducerWithInitialState(initialState)
  .case(actions.registerStep, registerStepHandler)
  .case(actions.setActiveStep, setActiveStepHandler)
  .case(actions.completeStep, completeStepHandler)
  .case(actions.removeCompletedStep, removeCompletedStepHandler)
  .case(actions.consumeLocallyStoredStep, consumeLocallyStoredStepHandler)
  .case(actions.setCheckoutFromLocalStorage.done, setCheckoutFromLocalStorageHandler)
  .case(actions.placeOrder.done, placeOrderCompleteHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/checkout.ts